import React from 'react';
import { BookOpenIcon, LockIcon, DownloadIcon } from 'lucide-react';
export function SiteFooter() {
  return <footer className="bg-cream py-10 pb-24 md:py-14" data-id="element-181" data-mp="3r9ap7f7ufjz7">
      <div className="mx-auto max-w-3xl px-5 text-center md:px-8" data-id="element-182" data-mp="3mhj95ymbcwnb">
        <div className="flex items-center justify-center gap-2" data-id="element-183" data-mp="3mfyapxwvotk6">
          <BookOpenIcon className="h-5 w-5 text-gold" aria-hidden="true" data-id="element-184" data-mp="3hj7yjlo72i41" />
          <p className="font-serif text-xl font-semibold text-ink sm:text-2xl" data-id="element-185" data-mp="3dgl3lbw88h2m">El Poder de los Salmos</p>
        </div>
        <p className="mt-3 text-sm text-muted sm:text-base" data-id="element-186" data-mp="38hi8aj61tp7u">
          Un espacio para la Palabra, la reflexión y el crecimiento espiritual.
        </p>
        <p className="mt-2 font-serif text-base italic text-gold-dark sm:text-lg" data-id="element-187" data-mp="33krih44fzf98">
          Que cada lectura sea una oportunidad para detenerte, agradecer y seguir caminando con fe.
        </p>
        <div className="mt-6 flex flex-col items-center justify-center gap-2 border-t border-line pt-5 text-xs text-muted sm:mt-8 sm:flex-row sm:gap-6 sm:pt-6 sm:text-sm" data-id="element-188" data-mp="11p7obqedb3ei">
          <span data-id="element-189" data-mp="15q2bkrs31aas">© 2026 · Todos los derechos reservados.</span>
          <span className="flex items-center gap-1.5" data-id="element-190" data-mp="1apokip0vo4ds">
            <LockIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-191" data-mp="1ar9kiu5yofj1" /> Compra segura
          </span>
          <span className="flex items-center gap-1.5" data-id="element-192" data-mp="vuij6fcq8tqs">
            <DownloadIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-193" data-mp="10qz65686x22a" /> Producto digital
          </span>
        </div>
      </div>
    </footer>;
}